import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecretariaRoutingModule } from './secretaria-routing.module';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { ListboxModule } from 'primeng/listbox';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextareaModule } from 'primeng/inputtextarea';

import { EditorModule } from '@tinymce/tinymce-angular';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { TableModule } from 'primeng/table';
import { FormSecretariaComponent } from './form-secretaria/form-secretaria.component';
import { FileUploadModule } from 'primeng/fileupload';
import { DataViewModule, DataViewLayoutOptions } from 'primeng/dataview';


@NgModule({
  declarations: [
    FormSecretariaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,

    DropdownModule,
    CalendarModule,
    DialogModule,
    TableModule,
    ListboxModule,
    CheckboxModule,
    InputTextModule,
    InputMaskModule,
    TooltipModule,
    InputTextareaModule,
    EditorModule,
    CurrencyMaskModule,
    FileUploadModule,
    DataViewModule,


    SecretariaRoutingModule
  ],
  providers: []
})
export class SecretariaModule { }
